import React from 'react';
import Typography from '@material-ui/core/Typography';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import map from 'lodash/map';

import CustomModal from '../Modals/Modal';
import Link from '../Link/Link';
import s from './BundleCertDetails.scss';
import messages from './messages';
import { ModalCloseBtn } from '../statelessComponents/Buttons/ButtonsInModals';
import Attachment from '../ReduxFormAttachments/Attachment/Attachment';

const BundleCertDetails = props => {
  const {
    isOpen,
    name,
    onClose,
    certificates,
    files,
    ariaDescribedBy,
    includedCertsTitle,
    attachedFilesTitle,
  } = props;

  return (
    <CustomModal
      aria-describedby={ariaDescribedBy}
      isOpen={isOpen}
      width="60%"
      onClose={onClose}
    >
      <div className={s.certList}>
        {!!certificates?.length && (
          <>
            <Typography variant="h5" component="h1">
              {includedCertsTitle || (
                <FormattedMessage
                  {...messages.includedCertsTitle}
                  values={{ certName: name }}
                />
              )}
            </Typography>
            {map(certificates, item => (
              <Link
                data-test-id="0KTKHpdqXo0BzbLkPzBAJ"
                to={`/cert/${item.code}`}
                target="_blank"
                key={item._id}
                onClick={onClose}
              >
                <Typography variant="body1">
                  <FormattedMessage
                    values={{
                      name: item.name,
                      supervisorOrganization: item.supervisorOrganization || '',
                      supervisor: item.supervisor || '',
                      code: item.code,
                    }}
                    {...messages.certItem}
                  />
                </Typography>
              </Link>
            ))}
          </>
        )}
        {!!files?.length && (
          <>
            <Typography variant="h5" component="h1">
              {attachedFilesTitle || (
                <FormattedMessage {...messages.certsFilesTitle} />
              )}
            </Typography>
            <div>
              {files.map(item => (
                <Attachment
                  key={item.path}
                  item={item}
                  total={files.length}
                  readOnly
                  displayConcisely
                />
              ))}
            </div>
          </>
        )}
      </div>
      <ModalCloseBtn
        data-test-id="jMzJ_KYHUAYYBuv5HpzJw"
        fitMobileLandscapeFullWidth
        onClick={onClose}
      />
    </CustomModal>
  );
};

BundleCertDetails.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  files: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
    }),
  ),
  name: PropTypes.string.isRequired,
  certificates: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      _id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      supervisorOrganization: PropTypes.string,
      supervisor: PropTypes.string,
    }),
  ).isRequired,
  onClose: PropTypes.func.isRequired,
  ariaDescribedBy: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
  includedCertsTitle: PropTypes.string,
  attachedFilesTitle: PropTypes.string,
};

BundleCertDetails.defaultProps = {
  files: [],
  includedCertsTitle: '',
  attachedFilesTitle: '',
};
export default compose(injectIntl, withStyles(s))(BundleCertDetails);
